<template>
    <div class="form-group" :class="formGroupClass">
        
        <div 
        class="d-flex align-items-center 
        form-check form-switch pe-md-3"
        :class="reverse 
        ? 'flex-row-reverse justify-content-end' 
        : 'justify-content-between'">

            <label 
            :class="small ? 'small' : ''"
            class="form-check-label" 
            :for="id"
            v-html="$sanitize(label)" />

            <input 
            :id="id"
            ref="checkbox"
            type="checkbox"
            :checked="isChecked" 
            :value="value" 
            @change="updateInput"
            v-bind="$attrs"
            class="form-check-input me-4 flex-shrink-0">

        </div>

    </div> <!-- /.form-group -->
</template>

<script>
    export default {

        model: {
            prop: 'modelValue',
            event: 'change'
        },

        props: {

            id: {
                type: String,
                default() {
                    return `checkbox-${this._uid}`
                },
            },

            label: {
                type: String,
                default: '',
            },

            reverse: {
                type: Boolean,
                default: true
            },

            small: {
                type: Boolean,
                default: false
            },

            checked: {
                type: Boolean,
                default: null
            },

            formGroupClass: {
                type: [String, Array],
                default: ''
            },

            value: {
                type: [String, Boolean],
                default: ''
            },

            modelValue: { 
                default: "" 
            },

            trueValue: {
                type: [String, Boolean],
                default: true
            },

            falseValue: {
                type: [String, Boolean],
                default: false
            }

        },

       computed: {
            isChecked() {

                if(_.isBoolean(this.checked)) {
                    return this.checked
                }

                if(this.modelValue instanceof Array) {
                    return this.modelValue.includes(this.value)
                }

                var value = this.value ? this.value : this.trueValue
                return this.modelValue === value
            }
        },

        methods: {
            updateInput(event) {

                let isChecked = event.target.checked
                
                if(this.modelValue instanceof Array) {
                    let newValue = [...this.modelValue]
                    
                    if (isChecked) {
                        newValue.push(this.value)
                    } 
                    else
                    {
                        newValue.splice(newValue.indexOf(this.value), 1)
                    }
                    
                    this.$emit('change', newValue)
                }
                else
                {
                    var value = this.value ? this.value : this.trueValue
                    this.$emit('change', isChecked ? value : this.falseValue)
                }
            }
        }
    }
</script>